import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=234207c5"
import script from "./Galleries.vue?vue&type=script&lang=js"
export * from "./Galleries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports